import { intParser, floatParser } from './functions.js';

const createField = config => Object.freeze(config);

const fields = {
    FP: createField({
        model: 'FP',
        minModel: 'fpMin',
        maxModel: 'fpMax',
        minDatasetKey: 'fpMin',
        maxDatasetKey: 'fpMax',
        defaultDatasetKey: 'fpDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 12,
        parser: intParser,
    }),

    Age: createField({
        model: 'Age',
        minModel: 'ageMin',
        maxModel: 'ageMax',
        minDatasetKey: 'ageMin',
        maxDatasetKey: 'ageMax',
        defaultDatasetKey: 'ageDefault',
        defaultValue: 18,
        minDefault: 3,
        maxDefault: 100,
        parser: intParser,
    }),

    MUL: createField({
        model: 'MUL',
        minModel: 'mulMin',
        maxModel: 'mulMax',
        minDatasetKey: 'mulMin',
        maxDatasetKey: 'mulMax',
        defaultDatasetKey: 'mulDefault',
        defaultValue: 12,
        minDefault: 0,
        maxDefault: 100,
        parser: intParser,
    }),

    ICIQ: createField({
        model: 'ICIQ',
        minModel: 'iciqMin',
        maxModel: 'iciqMax',
        minDatasetKey: 'iciqMin',
        maxDatasetKey: 'iciqMax',
        defaultDatasetKey: 'iciqDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 21,
        parser: intParser,
    }),

    IPSS: createField({
        model: 'IPSS',
        minModel: 'ipssMin',
        maxModel: 'ipssMax',
        minDatasetKey: 'ipssMin',
        maxDatasetKey: 'ipssMax',
        defaultDatasetKey: 'ipssDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 35,
        parser: intParser,
    }),

    IIEFEF: createField({
        model: 'IIEFEF',
        minModel: 'iiefEfMin',
        maxModel: 'iiefEfMax',
        minDatasetKey: 'iiefEfMin',
        maxDatasetKey: 'iiefEfMax',
        defaultDatasetKey: 'iiefEfDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 30,
        parser: intParser,
    }),

    ProstateSize: createField({
        model: 'ProstateSize',
        minModel: 'prostateSizeMin',
        maxModel: 'prostateSizeMax',
        minDatasetKey: 'prostateSizeMin',
        maxDatasetKey: 'prostateSizeMax',
        defaultDatasetKey: 'prostateSizeDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 250,
        parser: intParser,
    }),

    BMI: createField({
        model: 'BMI',
        minModel: 'bmiMin',
        maxModel: 'bmiMax',
        minDatasetKey: 'bmiMin',
        maxDatasetKey: 'bmiMax',
        defaultDatasetKey: 'bmiDefault',
        defaultValue: 25,
        minDefault: 10,
        maxDefault: 80,
        parser: intParser,
    }),

    CT: createField({
        model: 'CT',
        minModel: 'ctMin',
        maxModel: 'ctMax',
        minDatasetKey: 'ctMin',
        maxDatasetKey: 'ctMax',
        defaultDatasetKey: 'ctDefault',
        defaultValue: 1,
        minDefault: 1,
        maxDefault: 8,
        parser: intParser,
    }),

    PSA: createField({
        model: 'PSA',
        minModel: 'psaMin',
        maxModel: 'psaMax',
        minDatasetKey: 'psaMin',
        maxDatasetKey: 'psaMax',
        defaultDatasetKey: 'psaDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 1000,
        parser: floatParser,
    }),

    IPSSStorageDomain: createField({
        model: 'IPSSStorageDomain',
        minModel: 'ipssStorageMin',
        maxModel: 'ipssStorageMax',
        minDatasetKey: 'ipssStorageMin',
        maxDatasetKey: 'ipssStorageMax',
        defaultDatasetKey: 'ipssStorageDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 15,
        parser: intParser,
    }),

    IPSSVoidingDomain: createField({
        model: 'IPSSVoidingDomain',
        minModel: 'ipssVoidingMin',
        maxModel: 'ipssVoidingMax',
        minDatasetKey: 'ipssVoidingMin',
        maxDatasetKey: 'ipssVoidingMax',
        defaultDatasetKey: 'ipssVoidingDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 20,
        parser: intParser,
    }),

    ISUPGradeBx: createField({
        model: 'ISUPGradeBx',
        minModel: 'isupMin',
        maxModel: 'isupMax',
        minDatasetKey: 'isupMin',
        maxDatasetKey: 'isupMax',
        defaultDatasetKey: 'isupDefault',
        defaultValue: 1,
        minDefault: 1,
        maxDefault: 5,
        parser: intParser,
    }),

    CN: createField({
        model: 'CN',
        minModel: 'cnMin',
        maxModel: 'cnMax',
        minDatasetKey: 'cnMin',
        maxDatasetKey: 'cnMax',
        defaultDatasetKey: 'cnDefault',
        defaultValue: 0,
        minDefault: 0,
        maxDefault: 1,
        parser: intParser,
    }),
};

export default fields;
